<template>
  <div class="footer">
    <div class="text-white">
      <a
        class="px-2"
        target="_blank"
        href="https://www.cds-global.com/"
      >CDS Global</a>| 1901 Bell Avenue | Des Moines, IA 50315
    </div>
    <div class="text-white">
      &copy; 2018 All Rights Reserved |
      <a
        class="px-2"
        target="_blank"
        href="https://www.cds-global.com/company/privacy-notice"
      >Privacy Policy</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
  @import '~@/assets/styles/footer.scss';
</style>

